import { generatePath, useParams, useSearchParams } from 'react-router-dom';

interface Props {
  path: string;
}

export const AngularRouter = (props: Props): JSX.Element => {
  const { path } = props;
  const params = useParams();
  const searchParams = useSearchParams();

  // use react-router-dom to generate the Angular URLs? Sure!
  let fullPath = generatePath(path, params);

  if (searchParams) {
    const urlParams = searchParams[0];
    const keys = urlParams.keys();
    let queryParams = '';

    let key = keys.next();
    while (!key.done) {
      const keyValue = urlParams.get(key.value);

      // Strip the migration ?force= param — its job is done once HAProxy has
      // routed this request. Preserving it would loop any unmigrated route hit
      // under ?force=family/caregiver back to React.
      if (keyValue && keyValue !== 'null' && key.value !== 'force') {
        queryParams += `${key.value}=${encodeURIComponent(keyValue)}&`;
      }

      key = keys.next();
    }

    if (queryParams.length) {
      fullPath += `?${queryParams.replace(/&+$/, '')}`;
    }
  }

  // we use replace so we don't go back to the redirected React route and instead
  // to the last place in the nav stack
  window.location.replace(`https://${window.location.hostname}/app/${fullPath}`);

  return <div />;
};
